module.exports = "https://img.zhijierongxing.com/saas/img/shop_tab2_bg.5eae20fc.png";